import { create } from "zustand";
import { devtools } from "zustand/middleware";

import type {
  CashLocation,
  CashLocationMutationCategory,
} from "~/providers/cash-location-provider";

interface CashLocationStoreState {
  selectedCashLocation?: CashLocation;
  selectedCashLocationMutationCategory?: CashLocationMutationCategory;
  cashLocationDialogOpen: boolean;
  cashLocationMutationCategoryDialogOpen: boolean;
  setSelectedCashLocation: (cashLocation?: CashLocation) => void;
  setSelectedCashLocationMutationCategory: (
    cashLocationMutationCategory?: CashLocationMutationCategory,
  ) => void;
  setCashLocationDialogOpen: (open: boolean) => void;
  setCashLocationMutationCategoryDialogOpen: (open: boolean) => void;
}

export const useCashLocationStore = create<CashLocationStoreState>()(
  devtools((set) => ({
    cashLocationDialogOpen: false,
    cashLocationMutationCategoryDialogOpen: false,
    setCashLocationDialogOpen: (open) =>
      set(() => ({ cashLocationDialogOpen: open })),
    setCashLocationMutationCategoryDialogOpen: (open) =>
      set(() => ({ cashLocationMutationCategoryDialogOpen: open })),
    setSelectedCashLocation: (selectedCashLocation) =>
      set(() => ({ selectedCashLocation })),
    setSelectedCashLocationMutationCategory: (
      selectedCashLocationMutationCategory,
    ) => set(() => ({ selectedCashLocationMutationCategory })),
  })),
);
